import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-[50vh] flex-col items-center justify-center gap-3">
      <h1 className="text-2xl font-semibold">{t('notFound')}</h1>
      <Link className="text-sm font-semibold text-brand-text" to="/">
        {t('nav.dashboard')}
      </Link>
    </main>
  );
}
